import types from './actionTypes';

const initialState = {
  loading: false,
  localAgencies: [],
  error: '',
};

const localAgencyReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_LOCAL_AGENCY_STATE:
      return initialState;
    case types.SYNC_LOCAL_AGENCIES.REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
      };
    case types.SYNC_LOCAL_AGENCIES.SUCCESS:
      return {
        ...state,
        loading: false,
        error: '',
        localAgencies: [...action.localAgencies],
      };
    case types.SYNC_LOCAL_AGENCIES.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error.message,
      };
    default:
      return state;
  }
};

export default localAgencyReducer;
